import i18n from 'i18next';
import k from './../../../../../i18n/keys';
import React, { useContext } from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import styled from 'styled-components';

import breakpoints from '../../../../../Shared/breakpoints';
import defaultStyles from '../../../../../Shared/WeddingStyles/DefaultStyles';
import GenericStyleContainer from '../../../../../Shared/WeddingStyles/GenericStyleContainer';
import WeddingContext from '../../../../../Shared/Context/WeddingContext';
import { ReactComponent as LoveLetter } from '../../../../../_assets/svg/rating-star-empty.svg';
import { useHistory, useLocation } from 'react-router-dom';

const StyledDialogContent = styled(DialogContent)`
  height: 400px;
  width: 500px;
  max-width: 65vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  h3,
  p {
    margin: 0px;
    margin-bottom: 12px;
  }
  button {
    background-color: transparent !important;
  }
`;

const IconContainer = styled.div`
  margin: 30px;
  svg {
    height: 100px;
    width: 100px;
    fill: ${({ weddingStyle }) => defaultStyles[weddingStyle].colors.primary.onWhite};
  }
  @media (max-width: ${breakpoints.xs}) {
    margin: 10px;
  }
`;

const StyledDialogActions = styled(DialogActions)`
  justify-content: center;
  button {
    width: 150px;
  }
`;

const StyledH2 = styled.h2`
  margin: 0 0 6px 0;
`;

const DemoWeddingHintDialog = ({ show, setShow }) => {
  const history = useHistory();
  const { search } = useLocation();
  const { weddingConfig } = useContext(WeddingContext);

  const handleClose = () => {
    setShow(false);
  };

  const startPayment = async () => {
    history.push(`/hochzeit-erstellen/1${search}`);
  };
  return (
    <Dialog
      open={show}
      onClose={handleClose}
      aria-labelledby="{messageTitle}"
      aria-describedby="{messageDescriptionText}"
      className="color-background-white"
    >
      <GenericStyleContainer weddingStyleData={defaultStyles[weddingConfig.weddingStyle]}>
        <StyledDialogContent className="color-background-white">
          <IconContainer weddingStyle={weddingConfig.weddingStyle}>
            <LoveLetter></LoveLetter>
          </IconContainer>
          <>
            <StyledH2>{i18n.t(k.CREATE_OWN_WEBSITE)}</StyledH2>
            <p>{i18n.t(k.SOME_FEATURES_DEACTIVATED_IN_DEMO)} </p>
            <p>{i18n.t(k.CAN_CREATE_OWN_WEDDING_WEBSITE)}</p>
          </>
        </StyledDialogContent>
        <StyledDialogActions className="color-background-white">
          <Button onClick={handleClose} color="secondary" variant="contained">
            {i18n.t(k.CANCEL)}
          </Button>
          <Button onClick={startPayment} color="primary" variant="contained">
            {i18n.t(k.LOGIN)}
          </Button>
        </StyledDialogActions>
      </GenericStyleContainer>
    </Dialog>
  );
};

export default DemoWeddingHintDialog;
